import { Environment } from 'enviroment/AppSettings'
import { HttpClient } from 'common/HttpClient'
import { IRecalculatePreOfferParams, IRecalculatePreOffertResponse } from './PreOfferServiceProps'

/**
 * Serwis używany do requestów związanych z preofertą (oferta będąca przed złożeniem wniosku)
 */
export class PreOfferService {
  private readonly _client: HttpClient;
  private readonly _preOfferRecalculateUrlPath = "/preoffer/recalculate";

  public constructor() {
    this._client = new HttpClient(Environment.apiUrl)
  }

  public async recalculatePreOffer(recalculatePreOfferParams: IRecalculatePreOfferParams): Promise<IRecalculatePreOffertResponse> {
     return (await this._client.post<IRecalculatePreOffertResponse, IRecalculatePreOfferParams>(
       this._preOfferRecalculateUrlPath, 
       recalculatePreOfferParams,
       true
     )).data;
  }
}
